import { useState } from "react";
import { Paper, Center, Loader, Text, Collapse, Group, Stack, Divider } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

import { ListWorkOrderDto } from "../../models/workorder.models";
import { useGetWorkOrdersByAssetIdQuery } from "../../api/workorder.api";
import { WorkOrderListItem } from "../WorkOrders/WorkOrderListItem";
import { ChildAssetsList } from "./ChildAssetsList";

interface AssetWorkOrderListProps {
	assetId: string;
	onSelect?: (workOrder: ListWorkOrderDto) => void;
	selectedWorkOrderId?: string | null;
}

export const AssetWorkOrderList = ({ assetId, onSelect, selectedWorkOrderId }: AssetWorkOrderListProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const { data: workOrders, isLoading } = useGetWorkOrdersByAssetIdQuery(assetId);

	const filteredWorkOrders = workOrders?.filter(workOrder => workOrder.Assets && workOrder.Assets.some(asset => asset.AssetId === assetId)) || [];

	const sortedWorkOrders = filteredWorkOrders.sort((a, b) => new Date(b.Created).getTime() - new Date(a.Created).getTime());

	if (!filteredWorkOrders || filteredWorkOrders.length === 0) {
		return null;
	}

	return (
		<Stack gap={0} mb="lg">
			<Divider mb="md" />
			<Group
				justify="space-between"
				py="sm"
				onClick={() => setIsOpen(!isOpen)}
				style={{ cursor: "pointer", marginBottom: isOpen ? "md" : 0 }}
			>
				<Group gap={8}>
					<Text fz="xs" fw="700" tt="uppercase" c="dimmed">
						Work Order History ({filteredWorkOrders.length})
					</Text>
				</Group>
				{isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
			</Group>

			<Collapse in={isOpen}>
				{isLoading ? (
					<Center>
						<Loader size="sm" mt="lg" />
					</Center>
				) : (
					<Paper p={0} radius="md" style={{ overflow: 'hidden' }}>
						{sortedWorkOrders.map(workOrder => (
							<WorkOrderListItem
								key={workOrder.WorkOrderId}
								workOrder={workOrder}
								selected={selectedWorkOrderId === workOrder.WorkOrderId}
								onSelect={onSelect ? onSelect : () => { }}
								showCategories={true}
							/>
						))}
					</Paper>
				)}
			</Collapse>
		</Stack>
	);
};
